import useTwinTranslation from '../../../../../utils/hooks/useTwinTranslation'
import { useFetchText } from '../../../../../utils/hooks/useFetchText'
import { ModalEditComponentProps } from '../../../../../baseComponents/ModalsLayouts/types'
import ModalDeleteFilled from '../../../../../baseComponents/ModalsLayouts/ModalDeleteFilled'


interface ModalDeleteCustomerBankProps extends ModalEditComponentProps { }

const ModalDeleteCustomerBank: React.FC<ModalDeleteCustomerBankProps> = ({ setOpened, onSubmit, allRowData }) => {
    const { t } = useTwinTranslation()

    const { handleFetchText } = useFetchText({
        onSubmit,
        url: '/api/app/customer/customerBank/updateCustomerBank',
        data: {
            id: allRowData?.id,
            active: !allRowData?.active
        }
    })
    let translations = {
        title: t('sureUnableCustomerBank', '¿Seguro quieres desactivar este banco del cliente?'),
        subtitle: t('onceDeletedCouldBeRecovered', 'Una vez desactivado se podrá reactivar de nuevo'),
        buttonAccept: t('unable', 'Desactivar')
    }
    if (!allRowData?.active) {
        translations = {
            title: t('sureEnableCustomerBank', '¿Seguro quieres activar este banco del cliente?'),
            subtitle: t('onceEnabledCouldBeDeletedF', 'Una vez activada se podrá desactivar de nuevo'),
            buttonAccept: t('enable', 'Activar')
        }
    }
    return (
        <ModalDeleteFilled opened={true} setOpened={setOpened} onCancel={() => setOpened(null)} onAccept={handleFetchText} translations={translations} />
    )
}

export default ModalDeleteCustomerBank